// extracted by mini-css-extract-plugin
module.exports = {"loadingButton":"component_loadingButton__3VTzI","inner":"component_inner__14GGj","loads":"component_loads__3FFnp","appear":"component_appear__2f85G","spin":"component_spin__Rkvr6"};